import { theme } from 'lib/theme';
import * as React from 'react';
import {
  ScrollView,
  StyleProp,
  StyleSheet,
  View,
  ViewStyle,
} from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { NAVIGATION_HEADER_HEIGHT } from './NavigationHeader';

type Props = {
  horizontalScrollView?: boolean;
  disableSafeAreaView?: boolean;
  disabled?: boolean;
  style?: StyleProp<ViewStyle>;
  children: React.ReactNode;
  compact?: boolean;
};

export const HeaderRow: React.FC<Props> = ({
  children,
  disabled,
  disableSafeAreaView,
  horizontalScrollView,
  style,
  compact,
}) => {
  const safeAreaStyleArray = [
    styles.safeAreaView,
    compact ? { minHeight: 0 } : { minHeight: NAVIGATION_HEADER_HEIGHT },
  ];

  const safeAreaComponent = disableSafeAreaView ? (
    <View style={safeAreaStyleArray}>{children}</View>
  ) : (
    <SafeAreaView style={safeAreaStyleArray} edges={['left', 'right']}>
      {children}
    </SafeAreaView>
  );

  const viewComponent = horizontalScrollView ? (
    <ScrollView
      horizontal
      contentContainerStyle={[
        styles.view,
        compact ? { minHeight: 0 } : { minHeight: NAVIGATION_HEADER_HEIGHT },
        disabled ? { opacity: 0.42 } : undefined,
        style,
      ]}
      style={{ pointerEvents: disabled ? 'none' : 'auto' }}
    >
      {safeAreaComponent}
    </ScrollView>
  ) : (
    <View
      style={[
        styles.view,
        disabled ? { opacity: 0.42 } : undefined,
        { pointerEvents: disabled ? 'none' : 'auto' },
        style,
      ]}
    >
      {safeAreaComponent}
    </View>
  );

  return viewComponent;
};

const styles = StyleSheet.create({
  safeAreaView: {
    flex: 1,
    alignItems: 'center',
    flexDirection: 'row',
  },
  view: {
    paddingHorizontal: theme.paddingHorizontal,
    justifyContent: 'center',
  },
});
